"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapP = void 0;
var id_fn_1 = require("../functions/id-fn");
var map_each_1 = require("./map-each");
var mapP = function (mapFn) { return (0, map_each_1.mapEach)(mapFn, id_fn_1.idfn, id_fn_1.idfn); };
exports.mapP = mapP;
